<div class="robot-order-history-modal" [testId]="'robot-order-history-modal'">
  <div class="history-header" *ngIf="robotName || robotId">
    <div class="history-title-block">
      <div class="history-title">{{ robotName || robotId }}</div>
      <div class="history-subtitle"> {{ 'robot-service.order.history.robot-id-label' | i18n }}: {{ robotId }} </div>
    </div>
  </div>

  <div class="history-panel">
    <nz-spin [nzSpinning]="loading">
      <div class="history-empty" *ngIf="!loading && historyItems.length === 0" [testId]="'robot-order-history-empty'">
        <i nz-icon nzType="profile" nzTheme="outline"></i>
        <span>{{ 'robot-service.order.history.empty' | i18n }}</span>
      </div>

      <div class="history-list-shell" *ngIf="historyItems.length > 0">
        <div class="history-scroll-body" (scroll)="onListScroll($event)" [testId]="'robot-order-history-scroll-body'">
          <div class="history-list" [testId]="'robot-order-history-list'">
            <div class="history-card" *ngFor="let item of historyItems; let i = index" [testId]="'robot-order-history-item-' + i">
              <div class="history-card-top">
                <div class="history-card-main">
                  <div class="history-order-label">{{ 'robot-service.order.history.order-id' | i18n }}</div>
                  <div class="history-order-id">{{ item.orderId || '-' }}</div>
                </div>
                <div class="history-card-side">
                  <nz-tag [nzColor]="getStatusColor(item.status)">{{ getStatusLabel(item.status) }}</nz-tag>
                  <div class="history-package-highlight">
                    {{ 'robot-service.order.history.package-days' | i18n }} {{ formatNumber(item.durationDays) }}
                    {{ 'robot-service.order.history.days-unit' | i18n }}
                  </div>
                </div>
              </div>

              <div class="history-facts-row">
                <div class="history-fact-item">
                  <span class="fact-label">{{ 'robot-service.order.history.created-time' | i18n }}</span>
                  <strong class="fact-value">{{ formatDate(item.createTime) }}</strong>
                </div>
                <div class="history-fact-item" *ngIf="item.paidTime">
                  <span class="fact-label">{{ 'robot-service.order.history.paid-time' | i18n }}</span>
                  <strong class="fact-value">{{ formatDate(item.paidTime) }}</strong>
                </div>
                <div class="history-fact-item">
                  <span class="fact-label">{{ 'robot-service.order.history.package-days' | i18n }}</span>
                  <strong class="fact-value">
                    {{ formatNumber(item.durationDays) }} {{ 'robot-service.order.history.days-unit' | i18n }}
                  </strong>
                </div>
              </div>

              <div class="history-bill-strip">
                <div class="summary-item">
                  <span class="summary-label">{{ 'robot-service.order.history.total-amount' | i18n }}</span>
                  <strong class="summary-value">{{ formatCurrency(item.priceCny) }}</strong>
                </div>
                <div class="summary-item">
                  <span class="summary-label">{{ 'robot-service.order.history.cash' | i18n }}</span>
                  <strong class="summary-value" [class.summary-value-muted]="!item.payableCash">{{
                    formatCurrency(item.payableCash)
                  }}</strong>
                </div>
              </div>

              <div class="history-points-row">
                <span class="point-badge point-badge-aile" [class.point-badge-muted]="!item.deductAilePoints">
                  {{ 'robot-service.order.history.aile-points' | i18n }} {{ formatNumber(item.deductAilePoints) }}
                </span>
                <span class="point-badge point-badge-uupon" [class.point-badge-muted]="!item.deductUUPonPoints">
                  {{ 'robot-service.order.history.uupon-points' | i18n }} {{ formatNumber(item.deductUUPonPoints) }}
                </span>
              </div>
            </div>
          </div>

          <div class="history-loading-more" *ngIf="loadingMore" [testId]="'robot-order-history-loading-more'">
            {{ 'common.loading' | i18n }}
          </div>
        </div>
      </div>
    </nz-spin>
  </div>
</div>
